import { render, staticRenderFns } from "./PenaltyDetails.vue?vue&type=template&id=eeda2aaa"
import script from "./PenaltyDetails.vue?vue&type=script&lang=js"
export * from "./PenaltyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports